import HipAPI from '@/lib/HipApi';

const hipApi = HipAPI.getInstance();

function getUserStatus(user: any): string {
    if (user.isSuspended) return 'suspended';
    if (user.userId) return 'active';
    return 'pending';
}

const state = () => ({
    employees: [],
    employeesTableLoading: false,
});

const mutations = {
    setEmployees(state: any, payload: any) {
        state.employees = payload.employees;
    },
    setEmployeesTableLoading(state: any, payload: any) {
        state.employeesTableLoading = payload;
    },
};

const actions = {
    getEmployees({ commit, state }: any) {
        commit('setEmployeesTableLoading', true);
        hipApi
            .getUsers()
            .then((res: any) => {
                const { users } = res;
                const data = users.map((u: any, index: number) => {
                    u.status = getUserStatus(u);
                    u.userId = !u.userId ? index * -1 : u.userId;
                    return u;
                });
                commit('setEmployees', { employees: data });
            })
            .catch((err) => {
                commit('notificationDialog/showMessage', { type: 'error', title: 'Error', msg: err?.error?.message || err?.message || err }, { root: true });
            })
            .finally(() => {
                commit('setEmployeesTableLoading', false);
            });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
